// extracted by mini-css-extract-plugin
module.exports = {"postMemory":"Post_postMemory__H0hkL","postWMemory":"Post_postWMemory__eOF9E","post":"Post_post__kgbKw"};